import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  useMediaQuery,
  TextField,
  Autocomplete,
} from "@mui/material";
import formatDateAndTime from "../../common/formatDateAndTime";
import toast from "react-hot-toast";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Commongrid from "../../common/Commongrid";
import Viewissuesdetail from "./VIewissuesdetial";
import { Plus, Upload, X } from "lucide-react";
import { createFilterOptions } from "@mui/material/Autocomplete";

function createData(
  id,
  trackingid,
  bookingid,
  type,
  vehicleName,
  vehicleNo,
  city,
  status,
  priority,
  createdAt,
  costtocompany,
  action,
) {
  return {
    id,
    trackingid,
    bookingid,
    type,
    vehicleName,
    vehicleNo,
    city,
    status,
    priority,
    createdAt,
    costtocompany,
    action,
  };
}

const Viewallissues = ({ setActiveItem }) => {
  const querydisplay = new URLSearchParams(window.location.search).get(
    "display",
  );
  const queryIssueId = new URLSearchParams(window.location.search).get(
    "issueId",
  );
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const isMobile = useMediaQuery("(max-width:768px)");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [openTab, setOpenTab] = useState(false);
  const [allIssues, setAllIssues] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const issueType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueType;
  delete issueType?.inverted;
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueStatus;
  const issuePriority = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issuePriority;
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleId, setVehicleId] = useState(null);
  const [copied, setCopied] = useState(false);
  const catalogRoles = JSON.parse(localStorage.getItem("catalogValues"))?.role
    ?.inverted?.franchiseAdmin;
  const catalogRActions = JSON.parse(localStorage.getItem("catalogValues"))
    ?.action?.inverted?.viewMyCityBookings;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [searchVelues, setSearchvalues] = useState("");
  const [listofSearchValues, setListofSearchValues] = useState([]);
  const [selectSearchValues, setSelectSearchValues] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 70,
      align: "start",
      sortable: false,
    },
    {
      field: "trackingid",
      headerName: "Tracking Id",
      minWidth: 250,
      align: "start",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "bookingid",
      headerName: "Booking Id",
      minWidth: 200,
      align: "start",
      sortable: false,
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 180,
      align: "start",
      sortable: false,
      renderCell: (params) =>
        params.value === "Critical" ? (
          <Box
            sx={{
              color: "#fa1805",
              fontWeight: 700,
              px: 1,
              py: 0.5,
              borderRadius: 1,
              textAlign: "center",
              width: "100%",
            }}
          >
            {params.value || "-"}
          </Box>
        ) : (
          <Box
            sx={{
              color: "#faee05",
              fontWeight: 700,
              px: 1,
              py: 0.5,
              borderRadius: 1,
              textAlign: "center",
              width: "100%",
            }}
          >
            {params.value || "-"}
          </Box>
        ),
    },
    {
      field: "vehicleName",
      headerName: "Vehicle Name",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "vehicleNo",
      headerName: "Vehicle No",
      minWidth: 150,
      align: "start",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "city",
      headerName: "City",
      minWidth: 190,
      align: "start",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 190,
      align: "start",
    },
    {
      field: "priority",
      headerName: "Priority",
      minWidth: 190,
      align: "start",
    },
    {
      field: "createdAt",
      headerName: "Created At",
      minWidth: 190,
      align: "start",
    },
    {
      field: "costtocompany",
      headerName: "Cost to Company",
      minWidth: 190,
      align: "start",
    },
    // {
    //   field: "acion",
    //   headerName: "Action",
    //   minWidth: 140,
    //   align: "start",
    //   renderCell: (params) => {
    //     const row = params.row; // 👈 FULL ROW DATA

    //     return (
    //       <Button
    //         sx={{
    //           bgcolor: "#4556f1ff",
    //           fontWeight: 500,
    //           px: 1,
    //           color: "white",
    //           // py: 0.5,
    //           borderRadius: 1,
    //           textAlign: "center",
    //           width: "100%",
    //           cursor: "pointer",
    //         }}
    //         onClick={() => {
    //           setOpenTab(true);
    //         }}
    //       >
    //         View
    //       </Button>
    //     );
    //   },
    // },
  ];

  const rows =
    (allIssues &&
      allIssues?.map((item) =>
        createData(
          item?.id,
          item?.code,
          item?.bookingCode || "-",
          issueType[item?.type],
          item?.vehicleName || "/",
          item?.vehicleRegistration || "/",
          item?.cityText,
          issueStatus[item?.status],
          issuePriority[item?.priority],
          formatDateAndTime(item?.createdAt),
          item?.costToTheCompany,
          "View",
        ),
      )) ||
    [];

  useEffect(() => {
    if (querydisplay) {
      setOpenTab(true);
    }
  }, [querydisplay]);

  useEffect(() => {
    if (searchVelues.length > 3) {
      searchOnTheFilterBy();
    }
  }, [searchVelues]);

  const getVehicleData = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicles?limit=1000`, {
        method: "GET",
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleFilterListings(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  useEffect(() => {
    getVehicleData();
  }, []);

  const searchOnTheFilterBy = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    setListLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/advancesearch/search?key=vehicleIssues&queryStr=${searchVelues}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setListLoading(false);
        setListofSearchValues(data?.dataValues);
      } else {
        setListLoading(false);
        toast.error(data);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    getAllIssues();
  }, []);

  const getAllIssues = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
  ) => {
    setLoading(true);
    const offset = (customPage ?? 0) * (customRowsPerPage ?? rowsPerPage);
    let query = "";

    // if (
    //   profile?.roles.includes(Number(catalogRoles)) ||
    //   profile?.actions.includes(Number(catalogRActions))
    // ) {
    //   query += `&cityId=${profile?.cityId}`;
    // }
    // else if (profile?.actions.includes(Number(catalogRActions))) {
    //   query += `&cityId=${profile?.cityId}`;
    // }

    if (selectSearchValues != null && selectSearchValues !== "") {
      query += `&id=${selectSearchValues}`;
    }

    if (vehicleId) {
      query += `&vehicleId=${vehicleId}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAllIssues(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  };

  const handleReset = () => {
    setPaginationModel({ page: 0, pageSize: 20 });
    setSearchvalues("");
    setVehicleId(null);
    setSelectSearchValues(null);
    setListofSearchValues([]);
  };

  useEffect(() => {
    getAllIssues(paginationModel.page, paginationModel.pageSize);
  }, [paginationModel, selectSearchValues, vehicleId]);

  const handleChange = async (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleGenerate = async () => {
    if (!form?.filtertype || !form?.startDate || !form?.endDate) {
      return toast.error("Fill Details to download report", {
        position: "top-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }

    try {
      const endpoint = `/api/reports/vehicle-issues?datefilterType=${
        form.filtertype
      }&startDate=${form.startDate + "T00:00"}&endDate=${
        form.endDate + "T23:59"
      }`;

      if (!endpoint) {
        toast.error("Report endpoint not defined!");
        return;
      }

      const url = `${apiUrl}${endpoint}`;
      const response = await toast.promise(
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        {
          loading: "Generating report...",
          success: "Report generated successfully!",
          error: "Failed to generate report!",
        },
      );

      const data = await response.json();
      if (data?.statusCode === "0100" && data?.entities?.result === -1) {
        toast.error(data?.entities?.msg, {
          position: "top-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      } else {
        setOpen(false);
        setForm({});
        window.open(data.entities.Location, "_blank");
        toast.success("Report generated successfully", {
          position: "top-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
    } catch (error) {
      console.error("Error generating report:", error);
    }
  };

  const filterOptions = createFilterOptions({
    stringify: (option) =>
      `${option.id} ${option.name} ${option.licensePlate ?? ""}`,
  });

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 h-screen">
          <div className="bg-white w-full max-w-lg rounded-xl shadow-xl p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Block Report Download</h3>
              <button
                onClick={() => {
                  setOpen(false);
                  setForm({});
                }}
              >
                <X className="text-slate-500 hover:text-red-500" />
              </button>
            </div>

            {/* Form */}
            <div className="space-y-4">
              {/* <select
                    className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                    value={form.city}
                    onChange={(e) => {
                      handleChange("city", e.target.value);
                      getHubNames(e.target.value);
                    }}
                  >
                    <option value="">Select City</option>
                    {Object.entries(cities).map(([key, label]) => (
                      <option key={key} value={key}>
                        {label}
                      </option>
                    ))}
                  </select>
    
                  <select
                    className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                    value={form.hub}
                    onChange={(e) => handleChange("hub", e.target.value)}
                  >
                    <option value="">Select Hub</option>
                    {hubs ? (
                      hubs.map((hub) => (
                        <option key={hub.id} value={hub.id}>
                          {hub.hubName}
                        </option>
                      ))
                    ) : (
                      <option disabled>Select City first</option>
                    )}
                  </select> */}

              <select
                className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                value={form.filtertype}
                onChange={(e) => handleChange("filtertype", e.target.value)}
              >
                <option value="">Select Date Filter Type</option>
                <option value="createdAt">Created At</option>
                {/* <option value="startDate">Blocked From</option>
                <option value="endDate">Blocked To</option> */}
              </select>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="startDate"
                    className="text-sm font-medium text-gray-700"
                  >
                    Start Date
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    name="startDate"
                    className="w-full border rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={form.startDate || ""}
                    onChange={(e) => handleChange("startDate", e.target.value)}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="endDate"
                    className="text-sm font-medium text-gray-700"
                  >
                    End Date
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    name="endDate"
                    className="w-full border rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={form.endDate || ""}
                    min={form.startDate} // 🔥 prevents earlier date selection
                    onChange={(e) => handleChange("endDate", e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => {
                  setOpen(false);
                  setForm({});
                }}
                className="px-4 py-2 border rounded-lg text-sm"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleGenerate();
                }}
                className="px-5 py-2 bg-teal-600 text-white rounded-lg text-sm hover:bg-teal-700"
              >
                Generate
              </button>
            </div>
          </div>
        </div>
      )}
      {!openTab ? (
        <>
          <div className="flex justify-between p-4">
            <h1 className="text-xl md:text-2xl font-bold">View all Issues</h1>
            <div className="relative w-[700px]">
              <input
                autoComplete="off"
                placeholder="Search based on Issue id and Booking id..."
                className="input shadow-lg focus:border-2 border-gray-300 px-5 py-3 rounded-xl w-full outline-none"
                name="search"
                type="text"
                value={searchVelues}
                onChange={(e) => {
                  setSearchvalues(e.target.value);
                  setShowDropdown(true);
                }}
              />

              {listLoading ? (
                <svg
                  className="size-6 absolute top-3 right-3 animate-spin text-gray-500"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="blue"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    strokeWidth="1.5"
                    className="opacity-25"
                  />
                  <path
                    d="M21 12a9 9 0 0 1-9 9"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    className="opacity-75"
                  />
                </svg>
              ) : (
                <svg
                  className="size-6 absolute top-3 right-3 text-gray-500"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                  />
                </svg>
              )}

              {listofSearchValues?.length > 0 && (
                <div className="absolute z-50 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-auto">
                  {listofSearchValues.map((item) => (
                    <div
                      key={item.id}
                      className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        setSelectSearchValues(item.id);
                        setSearchvalues(
                          item.vehicleRegistration +
                            "-" +
                            item?.code +
                            "-" +
                            item?.summary,
                        );
                        setShowDropdown(false); // 👈 CLOSE
                      }}
                    >
                      {item.vehicleRegistration +
                        "-" +
                        item?.code +
                        "-" +
                        item?.summary}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <Autocomplete
              disablePortal
              options={vehicleFilterListings}
              value={selectedVehicle}
              onChange={(e, value) => {
                setSelectedVehicle(value);
                setVehicleId(value?.id);
              }}
              filterOptions={filterOptions}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) => option.name || ""}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <div className="flex flex-col">
                    <span className="font-medium">
                      {option.name} – {option.licensePlate}
                    </span>
                    <span className="text-xs text-gray-500">
                      {option.cityText} • {option.vehicleGroupText}
                    </span>
                  </div>
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search by Vehicle" size="small" />
              )}
              sx={{
                width: 420,
                backgroundColor: "#fff",
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ddd" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#bbb",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#999",
                },
              }}
            />

            <button
              onClick={() => {
                handleReset();
              }}
              class="cursor-pointer transition-all bg-blue-500 text-white px-4 py-2 rounded-lg
border-blue-600
border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px]
active:border-b-[2px] active:brightness-90 active:translate-y-[2px]"
            >
              Reset
            </button>

            <button
              title="Download Issue Report"
              onClick={() => {
                setOpen(true);
              }}
              className="p-5 rounded-full backdrop-blur-lg border border-blue-500/20 
      bg-gradient-to-tr from-white/60 to-white/40 shadow-lg 
      hover:shadow-2xl hover:shadow-blue-500/30 hover:scale-110 
      active:scale-95 transition-all duration-300 cursor-pointer 
      hover:border-blue-500/50 group relative overflow-hidden"
            >
              <div
                className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-400/20 to-transparent 
      -translate-x-full group-hover:translate-x-full transition-transform duration-700"
              />

              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-6 h-6 relative z-10"
                fill="currentColor"
              >
                <path d="M12 16l4-5h-3V4h-2v7H8l4 5zm6 2H6v2h12v-2z" />
              </svg>
            </button>
          </div>

          <Box p={isMobile ? 2 : 1}>
            <Paper
              sx={{
                boxShadow: 6,
                borderRadius: 2,
                mt: 4,
              }}
            >
              <Commongrid
                rows={rows}
                columns={columns}
                totalCount={totalCount}
                handleViewClick={handleViewClick}
                api={getAllIssues}
                setPaginationModel={setPaginationModel}
                paginationModel={paginationModel}
                loading={loading}
                disableColumnMenu={true}
              />
            </Paper>
          </Box>
        </>
      ) : (
        <>
          <Viewissuesdetail
            setSearchvalues={setSearchvalues}
            selectedRow={selectedRow}
            setSelectSearchValues={setSelectSearchValues}
            setOpenTab={setOpenTab}
            getAllIssues={getAllIssues}
            setPaginationModel={setPaginationModel}
          />
        </>
      )}
    </>
  );
};

export default Viewallissues;
